import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { CSSObject } from '@emotion/styled';
import { QcsTextField } from './basic/QcsTextField';
import { QcsLoadingButton } from './basic/QcsLoadingButton';
import { supplierEmployeeService } from '@api/services/services';
import { resources } from '@api/resources';
import { ShowError } from '../ShowError';

const PinContainer = styled.div(
  (): CSSObject => ({
    display: 'grid',
    gridTemplateColumns: 'auto max-content',
    gap: '1rem',
  })
);

interface SupplierEmployeePinRevealProps {
  supplierEmployeeId: string;
}

export const SupplierEmployeePinReveal: FC<SupplierEmployeePinRevealProps> = ({ supplierEmployeeId }) => {
  const { t } = useTranslation();
  const [pin, setPin] = useState('');

  const handleRevealOrHidePin = async () => {
    if (pin) {
      setPin('');
      return;
    }

    const pinData = await supplierEmployeeService.revealPin(supplierEmployeeId);
    setPin(pinData.data.pin!);
  };

  return (
    <>
      <PinContainer>
        <QcsTextField label={t('supplierEmployee.pin')} value={pin || '******'} disabled />
        <QcsLoadingButton onClick={handleRevealOrHidePin} resourceLoading={resources.revealPin}>
          {pin ? t('supplierEmployee.hidePin') : t('supplierEmployee.revealPin')}
        </QcsLoadingButton>
      </PinContainer>
      <ShowError resource={resources.revealPin} />
    </>
  );
};